<div mat-dialog-title class="title-text">{{title}}</div>
<div mat-dialog-content>
    <div class="message" [innerHTML]="message"></div>
</div>
<div mat-dialog-actions>
    @if (cancelCaption) {
    <button mat-stroked-button (click)="dialogRef.close(false)">
        <div>{{cancelCaption}}</div>
    </button>
    }
    <button mat-flat-button cdkFocusInitial (click)="dialogRef.close(ok)" translate>
        <div translate>{{okCaption}}</div>
    </button>
</div>